import Vue from 'vue'
import App from './App.vue'
import VueEasyLightbox from 'vue-easy-lightbox'
import store from './store'
import router from "./router";
import i18n from "./i18n";

Vue.config.productionTip = false

Vue.use(VueEasyLightbox)

Vue.prototype.$apiUrl = process.env.VUE_APP_API_URL;
Vue.prototype.$gasLimitBoost = 1.05;
Vue.prototype.$gasPriceBoost = 1.1;

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
